module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Valentino's Love-Child")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("“I’m not talking about sex.”")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "paraNoIndent1"
  }, [_c('span', [_vm._v("He turned her to face him, and lowered his head so his lips hovered above hers. “Let’s not talk at all.”")])]), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_c('span', [_vm._v("Then he kissed her. He would show her that they were too right together to dismiss their relationship because it wasn’t packaged in orange blossoms and meters of white tulle.")])]), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_c('span', [_vm._v("She fought her own response. He could feel the tension in her, knew she wanted to resist, but as much as she might want to, she was as much a slave to their mutual attraction as he. Her body knew where it belonged. In his arms.")])]), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_c('span', [_vm._v("But her brain was too active, and she tore her lips from his. “No, Tino.”")])]), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_c('span', [_vm._v("“Do not say no. Say, rather, ‘Make love to me, Tino.’ This is what I wish to hear.”")])])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page01"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f30d9e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/valentinoslovechild_fm01.vue
// module id = 57
// module chunks = 0